"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
var App_1 = require("../../App");
var DropDown = function (props) {
    var _a = (0, App_1.useEloise)(), theme = _a.theme, logic = _a.logic;
    var _b = (0, react_1.useState)(false), showWarningModal = _b[0], setShowWarningModal = _b[1];
    var handleCloseModal = function () { return setShowWarningModal(false); };
    var handleSelect = function (option) {
        if (props.warning) {
            setShowWarningModal(true);
        }
        else {
            props.setState(option);
        }
    };
    var displayText = (0, react_1.useMemo)(function () {
        if (props.state && props.options.includes(props.state)) {
            return props.state;
        }
        else if (props.label) {
            return props.label;
        }
        else {
            return "Select One";
        }
    }, [props.state, props.options, props.label]);
    var _c = (0, react_1.useState)("400px"), maxHeight = _c[0], setMaxHeight = _c[1];
    var dropdownRef = (0, react_1.useRef)();
    (0, react_1.useLayoutEffect)(function () {
        var calculateMaxHeight = function () {
            if (dropdownRef.current) {
                var rect = dropdownRef.current.getBoundingClientRect();
                var availableSpace = window.innerHeight - rect.top;
                setMaxHeight("".concat(availableSpace, "px"));
            }
        };
        calculateMaxHeight();
        window.addEventListener("resize", calculateMaxHeight);
        return function () {
            window.removeEventListener("resize", calculateMaxHeight);
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.default, { className: props.posClassName, style: { padding: props.margin ? props.margin : " 0" }, onChange: props.onChange },
            react_1.default.createElement(Dropdown_1.default.Toggle, { style: {
                    margin: "auto",
                    width: props.width ? props.width : "100%",
                    backgroundColor: props.color
                        ? typeof props.color === "number"
                            ? theme.colors[props.color]
                            : props.color
                        : theme.colors[0],
                    color: "black",
                }, variant: "success", id: "dropdown-basic" }, displayText),
            react_1.default.createElement(Dropdown_1.default.Menu, { style: { maxHeight: maxHeight, overflowY: "scroll" } }, props.options.map(function (option) { return (react_1.default.createElement(Dropdown_1.default.Item, { active: props.value == option ? true : false, key: option, onClick: function () {
                    handleSelect(option);
                } }, option)); }))),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: showWarningModal, onHide: handleCloseModal, centered: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Warning")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null, props.warningMessage),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement("button", { className: "btn btn-primary", onClick: handleCloseModal }, "Close")))));
};
exports.DropDown = DropDown;
